import PageLoader from "components/general/PageLoader";
import Seo from "components/general/Seo";
import { Box } from "components/ui";
import React from "react";
import GLAcoountsCollectionListingScreen from "screens/GLAcoountsCollectionListingScreen";
import { useGetGlAccountQuery } from "store/abcoApi";

export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	const { data, isLoading } = useGetGlAccountQuery({ pageNumber });

	if (isLoading || data == null) {
		return (
			<Box minHeight={150}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box>
			<Seo title="Admin | GL Accounts | Abconet" description="Configure and manage General Ledger accounts used for financial tracking and reporting." />
			<GLAcoountsCollectionListingScreen data={data} setPageNumber={setPageNumber} />
		</Box>
	);
}
